import { useEffect, useState } from "react";
import { Users, UserPlus, Building2, Video, Film, Flame, Radio, LifeBuoy, Lightbulb, Ban, Tag } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { DemoReset } from "@/components/admin/DemoReset";

const STATS = [
  ["users", Users, "#3ad7ff"], ["users_7d", UserPlus, "#22e3a1"], ["workspaces", Building2, "#2f7bff"],
  ["videos", Video, "#a746ff"], ["clips", Film, "#ff3df0"], ["clips_7d", Flame, "#ff8a3d"],
  ["live", Radio, "#ff4d6d", "live_now"], ["tickets", LifeBuoy, "#ffc94d", "tickets_open"],
  ["suggestions", Lightbulb, "#ffc94d"], ["suspended", Ban, "#ff4d6d"], ["version", Tag, "#3ad7ff"],
];

export const Overview = () => {
  const { t } = useI18n();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  return (<>
    <DemoReset />
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="admin-overview">
      {STATS.map(([k, Icon, c, field], i) => (
        <div key={k} className="cx-card rounded-2xl p-5 cx-rise" style={{ animationDelay: `${i * 0.03}s` }} data-testid={`admin-stat-${k}`}>
          <div className="flex items-center justify-between">
            <span className="cx-label">{t(`adm.s_${k}`)}</span>
            <Icon className="w-4 h-4" style={{ color: c }} />
          </div>
          <div className="font-display font-bold text-3xl sm:text-4xl text-white mt-3" style={{ textShadow: `0 0 24px ${c}55` }}>
            {k === "version" ? `V${s.version}` : s[field || k]}
          </div>
        </div>
      ))}
    </div>
  </>);
};
